const dateFn = {}

dateFn.days_names = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
dateFn.get_day_name = (weekDay) => {
  const days = dateFn.days_names;
  return days[weekDay];
};

dateFn.days_short_names = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
dateFn.get_day_short_name = (weekDay) => {
  const days = dateFn.days_short_names;
  return days[weekDay];
};

dateFn.days_letters = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
dateFn.get_day_letter = (weekDay) => {
  const days = dateFn.days_letters;
  return days[weekDay];
};

dateFn.months_names = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
dateFn.get_month_name = (month) => {
  const months = dateFn.months_names;
  return months[month];
};

dateFn.months_short_names = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
dateFn.get_month_short_name = (month) => {
  const months = dateFn.months_short_names;
  return months[month];
};

dateFn.get_date_object = (date_or_timestamp) => {
  var d = date_or_timestamp;
  if (typeof d !== 'object' || !(d instanceof Date)) {
    if (Number.isInteger(date_or_timestamp)) {
      d = new Date(date_or_timestamp * 1000);
    } else if (typeof date_or_timestamp === 'string') {
      d = new Date(date_or_timestamp.replace(' ', 'T'));
    } else {
      d = new Date(date_or_timestamp); // fallback generico
    }
  }
  return d;
}

dateFn.get_week_day_from_date = (date_or_timestamp) => {
  const d = dateFn.get_date_object(date_or_timestamp);

  return (d.getDay() + 6) % 7;
}

dateFn.format_unix_date = (date_or_timestamp) => {
  const d = dateFn.get_date_object(date_or_timestamp);
  
  return ('000' + d.getFullYear()).slice(-4) + '-'
    + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
    + ('0' + d.getDate()).slice(-2); 
}

dateFn.format_date = (date_or_timestamp) => {
  const d = dateFn.get_date_object(date_or_timestamp);
  
  return ('0' + d.getDate()).slice(-2) + '/'
    + ('0' + (d.getMonth() + 1)).slice(-2) + '/'
    + ('000' + d.getFullYear()).slice(-4); 
},

dateFn.format_datetime = (date_or_timestamp) => {
  const d = dateFn.get_date_object(date_or_timestamp);

  return dateFn.format_date(d) + ' ' + dateFn.format_time(d);
}

dateFn.format_time = (date_or_timestamp) => {
  if(typeof date_or_timestamp == 'object' && date_or_timestamp instanceof Date) return ("0" + date_or_timestamp.getHours()).slice(-2) + ":" + ("0" + date_or_timestamp.getMinutes()).slice(-2);

  const is_negative = date_or_timestamp < 0;
  date_or_timestamp = Math.abs(date_or_timestamp);
  
  var hours = Math.floor(date_or_timestamp / 3600);
  var minutes = Math.floor((date_or_timestamp / 60) - (hours * 60));
  //var seconds = date_or_timestamp - (hours * 3600) - (hours * 60);
  
  if(hours < 10) hours = '0' + hours;
  return (is_negative ? '-' : '') + hours + ':' + ('0'+minutes).slice(-2);
}

dateFn.remove_seconds_from_time = (time) => {
  return time.substring(0, time.length-3);
}

dateFn.get_seconds_from_time = time => {
  if(!time) return 0;
  
  const time_parts = time.split(':');
  if(time_parts.length < 2 || time_parts.length >3) return 0;

  var sum = (parseInt(time_parts[0]) * 60*60) + (parseInt(time_parts[1]) * 60);
  if(time_parts.length == 3) sum += parseInt(time_parts[2]);
  return sum;
}

dateFn.get_duration_text_from_seconds = seconds => {
  var text = '';

  var hours = Math.floor(seconds / 3600);
  if(hours) text += hours+'h'; 

  var minutes = Math.round((seconds - (hours * 3600)) / 60);
  if(minutes) text += (hours ? ' ' : '') + minutes+'m'; 

  return text;
}

dateFn.format_unix_datetime = (date_or_timestamp) => {
  const d = dateFn.get_date_object(date_or_timestamp);

  var hours = Math.floor(date_or_timestamp / 3600);
  var minutes = Math.floor((date_or_timestamp / 60) - (hours * 60));
  var seconds = date_or_timestamp - (hours * 3600) - (hours * 60);
  
  return ('000' + d.getFullYear()).slice(-4) + '-'
    + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
    + ('0' + d.getDate()).slice(-2) + ' '
    + ('0' + d.getHours()).slice(-2) + ':'
    + ('0' + d.getMinutes()).slice(-2) + ':'
    + ('0' + d.getSeconds()).slice(-2);
}

dateFn.months = [
  {
    label : 'Gennaio',
    md_label : 'Gen',
    sm_label : '1'
  },
  {
    label : 'Febbraio',
    md_label : 'Feb',
    sm_label : '2'
  },
  {
    label : 'Marzo',
    md_label : 'Mar',
    sm_label : '3'
  },
  {
    label : 'Aprile',
    md_label : 'Apr',
    sm_label : '4'
  },
  {
    label : 'Maggio',
    md_label : 'Mag',
    sm_label : '5'
  },
  {
    label : 'Giugno',
    md_label : 'Giu',
    sm_label : '6'
  },
  {
    label : 'Luglio',
    md_label : 'Lug',
    sm_label : '7'
  },
  {
    label : 'Agosto',
    md_label : 'Ago',
    sm_label : '8'
  },
  {
    label : 'Settembre',
    md_label : 'Set',
    sm_label : '9'
  },
  {
    label : 'Ottobre',
    md_label : 'Ott',
    sm_label : '10'
  },
  {
    label : 'Novembre',
    md_label : 'Nov',
    sm_label : '11'
  },
  {
    label : 'Dicembre',
    md_label : 'Dic',
    sm_label : '12'
  },
];

dateFn.get_time_from_seconds = (second) => {
  var hour = Math.floor(second/60/60);
  var minute = Math.floor((second-(hour*60*60)) / 60);

  return (hour<10 ? '0'+hour : hour)+':'+(minute<10 ? '0'+minute : minute);
}

dateFn.get_duration_text = (second) => {
  var hour = Math.floor(second/60/60);
  var minute = Math.floor((second-(hour*60*60)) / 60);

  var text = '';
  if(hour) text = hour+'h';

  if(minute) text += (hour ? ' ' : '') + (minute<10 ? '0'+minute : minute)+'m';

  return text;
}

export default dateFn;